import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import { Container, Row , Col } from 'reactstrap';
import SongsWithContacts from './SongsWithContacts/SongsWithContacts'
import SongsWithoutContacts from './SongsWithoutContacts/SongsWithoutContacts'
import EmptyPlayListDefault from './EmptyPlayListDefault/EmptyPlayListDefault'
import {addPhoneInput} from '../../fundialSlice';


const MyPlaylist = (props) => {
    const [totalSongs, setTotalSongs] = useState(0);
    const [songsWithContacts, setSongsWithContacts] = useState([]);
    const [songsWithoutContacts, setSongsWithoutContacts] = useState([]);


    useEffect(() => {
    
        if(props.data){

        let songsWithContacts = [];
        let songsWithoutContacts = [];
        
        setTotalSongs(parseInt(props.data?.totalCount) + parseInt(props.data.leftCount))
        props.data?.items.item.forEach((item, index) => {
            var contactsCount = parseInt(item.profiles.totalCount);
            if(contactsCount > 0){
                songsWithContacts.push(item);
                props.addPhoneInput({id:'phone-'+ item.productId , isActive: false , value: ''})
            }
            else{
                songsWithoutContacts.push(item);
                props.addPhoneInput({id: 'phone-'+ item.productId , isActive: false , value: ''})
            }
            
        });
        setSongsWithContacts(songsWithContacts);
        setSongsWithoutContacts(songsWithoutContacts);
    }

    },[props.data])

    return (
        <div className='my-playlist'>
          <div className='title'>
            <h2>הפלייליסט שלי</h2>
            {props.data?.totalCount > 0 && (
              <p className='sub-title'>
                יש לך <span className='bold-text'>{props.data?.totalCount}</span> מתוך{' '}
                <span className='bold-text'>{totalSongs}</span>
              </p>
            )}
            {props.data?.totalCount == 0 && <p className='sub-title'>אין לך עדיין שירים</p>}
          </div>
          <Row>
            {props.data?.totalCount == 0 ? (
              <Col xs='12' sm='12' md='12' lg='6'>
                <EmptyPlayListDefault />
              </Col>
            ) : (
              <>
                  {songsWithContacts.length > 0 && <Col xs='12' sm='12' md='12' lg='6'><SongsWithContacts data={songsWithContacts}></SongsWithContacts> </Col>}
                  {songsWithoutContacts.length > 0 && <Col xs='12' sm='12' md='12' lg='6'><SongsWithoutContacts data={songsWithoutContacts}></SongsWithoutContacts></Col>}
              </>
            )}
          </Row>
        </div>     
    );
}


const mapStateToProps = (state) => {
  return {
      form: state.fundialPage.form
  };
};

const mapDispatchToProps = {
  addPhoneInput,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyPlaylist);

